import m from "../../geodata/es2015/estoniaHigh";
window.am4geodata_estoniaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/estoniaHigh.js
// module id = null
// module chunks = 